const HeadphoneIcon = ({ className = '' }) => {
  return (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M57.0948 32.3508V30.309C57.0948 19.386 48.2088 10.5 37.2858 10.5C26.3627 10.5 17.4767 19.386 17.4767 30.309V32.3523C18.6355 32.1717 19.8353 32.3187 20.9599 32.8017C22.8469 33.6117 24.2029 35.2167 24.6829 37.2117L27.4039 48.6027C27.8809 50.5797 27.4069 52.6197 26.1109 54.1977C24.8929 55.6737 23.1349 56.5077 21.2509 56.5077C21.161 56.5077 21.074 56.5047 20.9843 56.502L20.9749 56.5017C20.3239 56.4717 19.6609 56.3937 18.9889 56.2617C14.3509 55.3497 10.5889 51.8097 9.41589 47.2437C8.22651 42.6129 9.64167 37.9224 12.9767 34.8273V30.309C12.9767 16.905 23.8817 6 37.2858 6C50.6898 6 61.5948 16.905 61.5948 30.309V34.8186C64.9356 37.9137 66.3516 42.6087 65.1561 47.2437C63.9861 51.8097 60.2271 55.3497 55.5831 56.2617C55.0794 56.3637 54.576 56.4315 54.0801 56.4714C49.839 63.6666 45.2424 64.5003 40.4043 64.5003C39.6843 64.5003 38.9589 64.4826 38.2272 64.4649L38.2083 64.4643C37.4403 64.4433 36.6453 64.4223 35.8203 64.4223C34.5783 64.4223 33.5703 63.4143 33.5703 62.1723C33.5703 60.9303 34.5783 59.9223 35.8203 59.9223C36.6843 59.9223 37.5183 59.9433 38.3253 59.9643H38.3286C43.3158 60.0927 46.3143 60.1698 49.5534 55.2435C49.1568 54.9438 48.7908 54.5937 48.4641 54.1977C47.1681 52.6197 46.6971 50.5797 47.1711 48.5997L49.8951 37.2147C50.3721 35.2167 51.7281 33.6117 53.6151 32.8017C54.7404 32.3202 55.9383 32.1726 57.0948 32.3508Z"
        fill="#FF9060"
      />
    </svg>
  )
}

export default HeadphoneIcon
